import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { serverurl } from "../../environments/environment";
import { SnackService } from "./snack.service";


@Injectable({
    providedIn: 'root'
})
export class CategoryService {
    constructor(
        private http: HttpClient,
        private snack: SnackService
    ) { }

    async getCategories() {
        return await new Promise((resolve) => {
            this.http.get(serverurl + '/category').subscribe({
                next: async (data: any) => {
                    // console.log(data);

                    for await (let categorie of data) {
                        try {
                            categorie.tags = JSON.parse(categorie.tags);
                        } catch (error) { }
                    }

                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async createCategory(data: any) {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/category', data).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err)
                    resolve(false);
                }
            })
        })
    }

    async updateCategory(id: string, data: any) {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/category/${id}`, data).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async deleteCategory(id: string) {
        return await new Promise((resolve) => {
            this.http.delete(`${serverurl}/category/${id}`).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    resolve(false);
                }
            })
        })
    }

    async updateOrderNumbers(data: any) {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/category/ordernr`, data).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    resolve(false);
                }
            })
        })
    }
}
